import { SurveyName } from '~/lib/constants/survey/SurveyName';

// @deprecated - don't want to break any existing logic, so keeping it for now.
export const SurveysToCheckForAlert: SurveyName[] = [
  SurveyName.C_SSRS_LIFETIME,
  SurveyName.C_SSRS_RECENT_SCREENER,
  SurveyName.C_SSRS_SINCE_LAST_CONTACT,
  SurveyName.C_SSRS_SLC_SCREENER,
];

export const CSSRSurveyNamesToCheckForAlert: SurveyName[] = [
  SurveyName.C_SSRS_LIFETIME,
  SurveyName.C_SSRS_SINCE_LAST_CONTACT,
  SurveyName.C_SSRS_SLC_SCREENER,
];
